export const apiTypesName = {
    'GET_ARTIST_AND_SERVICE_DATA': 'GET_ARTIST_AND_SERVICE_DATA',
    'EDIT_ARTIST_SERVICE': 'EDIT_ARTIST_SERVICE',
    'ADD_ARTIST_SERVICE': 'ADD_ARTIST_SERVICE',
    'DELETE_SERVICE': 'DELETE_SERVICE',
  }